import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DocumentKeys } from "web_myplann/Api/Document/DocumentKeys";
import { invalidateDocumentListsWhenIdle } from "web_myplann/Api/Document/invalidateDocumentListsWhenIdle";
import { removeDocumentFromCache } from "web_myplann/Api/Document/removeDocumentFromCache";
import { restoreDocumentListCache } from "web_myplann/Api/Document/restoreDocumentListCache";
import { deleteDocumentIdV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useDocumentDeleteMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationKey: DocumentKeys.mutation,
		mutationFn: processResponse((id: number) => deleteDocumentIdV2(id)),
		onMutate: (id: number) => removeDocumentFromCache(queryClient, id),
		onError: (_error, _id, snapshot) => {
			if (snapshot) {
				restoreDocumentListCache(queryClient, snapshot);
			}
		},
		onSettled: () => invalidateDocumentListsWhenIdle(queryClient),
	});
};
